export default {
  loading: false,
  notify: {
    visible: false,
    color: null,
    message: null,
    time: null,
  },
  tutorials: [
    {
      key: 'TSP0',
      title: 'Inserir Saldo',
      video: 'https://www.youtube.com/embed/Pibzmc7fcKs?si=qqNc7MWTssOKCAIt',
    },
    {
      key: 'TSP1',
      title: 'Criar SMS Template',
      video: 'https://www.youtube.com/embed/qfkbus82QDM',
    },
    {
      key: 'TSP2',
      title: 'Criar Campanha de SMS',
      video: 'https://www.youtube.com/embed/5eXrSlDe3-A',
    },
    {
      key: 'TSP3',
      title: 'Criar Campanha de Higienização',
      video: 'https://www.youtube.com/embed/HFaTDMFWayc',
    },
    {
      key: 'TSP4',
      title: 'Criar Campanha de Voz',
      video: 'https://www.youtube.com/embed/GK2QnFdwuX8',
    },
  ],
}
